/* eslint-disable */
import React from 'react';

import usePlatform from 'lib/hooks/usePlatform';
import VProLayout from './VProLayout';
import WPlusLayout from './WPlusLayout';

const Layout = ({ children, hasSidebarNav = true, isLoading }) => {
  const { isWebinarPlus } = usePlatform();
  return isWebinarPlus
    ? <WPlusLayout hasSidebarNav={hasSidebarNav} isLoading={isLoading}>{children}</WPlusLayout>
    : <VProLayout hasSidebarNav={hasSidebarNav} isLoading={isLoading}>{children}</VProLayout>;
};

export default Layout;
